import { obterJson } from './api';
import { config, url } from './config';

// Mesmas chaves e formatos do v1 (geoData.js e authBroadcast.js): a pessoa alterna entre telas v1 e v2.
const _chaveGeo = 'localizacaoGeoData';
const _ttlGeoMs = 6 * 60 * 60 * 1000;
const _chaveAuth = 'empregare-auth-event';

let _usuario = null;

// Uma chamada por página, sem cache: o HTML é público e o estado pessoal só chega por aqui.
export function obterUsuario() {
    if (!_usuario) {
        const { pedidos, conta } = config();
        const jaContados = Number.isInteger(pedidos);
        // O número que a página contou vai junto: o servidor guarda os números inteiros e a próxima página não reconta.
        // Do app, a sessão passa a durar mais (SegurancaWeb.RenovarSessaoAsync).
        const app = document.documentElement.hasAttribute('data-app') ? '&plataforma=app' : '';
        _usuario = obterJson(url(`/Login/GetUsuarioLogado?salvas=true${app}${jaContados ? `&semNotificacoes=true&pedidos=${pedidos}` : ''}`), { semCache: true })
            .then(resposta => {
                _gravarGeo(resposta?.geoData);
                if (resposta?.logado && jaContados) {
                    resposta.notificacoes = pedidos;
                }
                return resposta || { logado: false };
            })
            // Tela da conta (no-store): o servidor já pôs quem entrou no HTML; sem a resposta, o topo fica o de quem entrou, sem números.
            .catch(() => (conta ? { ...conta, logado: true, semResposta: true, mensagens: 0, notificacoes: jaContados ? pedidos : 0 } : { logado: false, erro: true }));
    }
    return _usuario;
}

function _gravarGeo(geo) {
    if (!geo || !geo.cidade) {
        return;
    }

    try {
        let cidade = decodeURIComponent(geo.cidade);
        // Os cabeçalhos cf-* às vezes chegam em latin-1 lido como UTF-8 (mesma correção do geoData.js do v1).
        cidade = cidade.replace(/£/g, '').replace(/Ã/g, 'ã').replace(/Â/g, 'â').replace(/Ê/g, 'ê').replace(/Î/g, 'î')
            .replace(/Ô/g, 'ô').replace(/Û/g, 'û').replace(/Á/g, 'á').replace(/É/g, 'é').replace(/Í/g, 'í').replace(/Ó/g, 'ó').replace(/Ú/g, 'ú');

        const atual = obterGeo();
        const expirou = !atual || !atual._ts || (Date.now() - atual._ts) > _ttlGeoMs;
        if (atual && atual.cidade === cidade && !expirou) {
            return;
        }

        localStorage.setItem(_chaveGeo, JSON.stringify({ ...geo, cidade, _ts: Date.now() }));
    } catch {
        // Armazenamento bloqueado (aba anônima, cota): a home fica com a versão nacional.
    }
}

export function obterGeo() {
    try {
        const geo = JSON.parse(localStorage.getItem(_chaveGeo));
        return geo && geo.cidade ? geo : null;
    } catch {
        return null;
    }
}

export function aoMudarLogin(funcao) {
    const carregadaEm = Date.now();
    const processar = () => {
        try {
            const salvo = JSON.parse(localStorage.getItem(_chaveAuth));
            if (!salvo || salvo.t < carregadaEm) {
                return;
            }
            const chaveProcessado = `${_chaveAuth}-${salvo.t}`;
            if (sessionStorage.getItem(chaveProcessado)) {
                return;
            }
            sessionStorage.setItem(chaveProcessado, '1');
            funcao(salvo.evento);
        } catch {
            // Armazenamento indisponível: sem sincronia entre abas.
        }
    };

    window.addEventListener('storage', e => {
        if (e.key === _chaveAuth && e.newValue) {
            processar();
        }
    });
    // Aba congelada pelo navegador recebe o evento quando volta a ficar visível.
    document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
            processar();
        }
    });
}

// A última entrada ou saída deste aparelho, em qualquer aba (o "t" do avisarLogin).
export function ultimoEventoLogin() {
    try {
        return JSON.parse(localStorage.getItem(_chaveAuth))?.t ?? null;
    } catch {
        return null;
    }
}

export function avisarLogin(evento) {
    try {
        const t = Date.now();
        sessionStorage.setItem(`${_chaveAuth}-${t}`, '1');
        localStorage.setItem(_chaveAuth, JSON.stringify({ evento, t }));
    } catch {
        // Sem armazenamento: as outras abas só percebem ao recarregar.
    }
}
